import * as signalR from "@microsoft/signalr";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalInstance, loginRequest } from "@/authConfig";
import { getLocalAuthToken } from "@/localAuth";

// The hub is mapped at the API's root ("/hubs/notifications"), not under the
// "/api/v1" prefix everything else in this app uses via apiClient.
const API_ROOT = (import.meta.env.VITE_API_BASE_URL as string).replace(/\/api\/v1\/?$/, "");

async function getAccessToken(): Promise<string> {
  const localToken = getLocalAuthToken();
  if (localToken) return localToken;

  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  if (!account) return "";

  try {
    const result = await msalInstance.acquireTokenSilent({ ...loginRequest, account });
    return result.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(loginRequest);
    }
    return "";
  }
}

let connection: signalR.HubConnection | null = null;

/** One shared connection for the whole app - callers add/remove their own
 * "ReceiveNotification" listeners rather than each opening their own socket. */
export function getNotificationsConnection(): signalR.HubConnection {
  if (!connection) {
    connection = new signalR.HubConnectionBuilder()
      .withUrl(`${API_ROOT}/hubs/notifications`, { accessTokenFactory: getAccessToken })
      .withAutomaticReconnect()
      .build();
  }
  return connection;
}
